import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import ContactForm from "../components/ContactForm";
import { speakerReasons, speakerFaqs, contact } from "../mock";
import { ChevronDown } from "lucide-react";

const Faq = ({ item, isOpen, onToggle }) => {
  return (
    <div className="border-b border-[#2a2a2a]">
      <button
        onClick={onToggle}
        className="w-full flex justify-between items-center py-5 text-left text-[#f5f1e8] hover:text-[#e8a13a] transition-colors"
      >
        <span className="font-semibold">{item.q}</span>
        <ChevronDown
          className={`w-5 h-5 flex-shrink-0 ml-4 transition-transform ${
            isOpen ? "rotate-180 text-[#e8a13a]" : ""
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ${
          isOpen ? "max-h-[600px] pb-5" : "max-h-0"
        }`}
      >
        <p className="text-[#d5c9a8] leading-relaxed text-sm">{item.a}</p>
      </div>
    </div>
  );
};

const BecomeSpeaker = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <div>
      <PageHeader title="You Should Become a BOT Speaker If..." />

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          {speakerReasons.map((r) => (
            <div
              key={r.title}
              className="bg-[#181818] border border-[#2a2a2a] hover:border-[#e8a13a]/60 transition-all duration-500 group"
            >
              <div className="overflow-hidden aspect-square">
                <img
                  src={r.image}
                  alt=""
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h4 className="font-display text-lg text-[#e8a13a] mb-4 leading-snug">
                  {r.title}
                </h4>
                <p className="text-[#d5c9a8] leading-relaxed text-sm">{r.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 px-6 bg-[#181818] border-y border-[#2a2a2a]">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl text-[#e8a13a] mb-3 text-center">
            Frequently Asked Questions
          </h2>
          <p className="text-center text-[#c8bfae] mb-10">
            Please reach us at{" "}
            <a href={`mailto:${contact.email}`} className="underline text-[#e8a13a]">
              {contact.email}
            </a>{" "}
            if you cannot find the answer to your question.
          </p>
          <div>
            {speakerFaqs.map((f, i) => (
              <Faq
                key={i}
                item={f}
                isOpen={openIdx === i}
                onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl text-[#e8a13a] mb-3 text-center">
            Interested in becoming a BOT Speaker?
          </h2>
          <p className="text-center text-[#c8bfae] mb-10">
            Let us pick your brain! Send us a message about yourself, and your areas of special
            interest. Specify if you have a specific geographical or event location where you
            would be interested in speaking.
          </p>
          <ContactForm title="" storageKey="bot_speaker_applications" />
          <p className="text-center mt-10 text-[#c8bfae] font-serif-italic">
            We look forward to meeting you in-person really soon.
          </p>
        </div>
      </section>
    </div>
  );
};

export default BecomeSpeaker;
